import { Site } from '@envato/foundation-types'
import * as React from 'react'
import { connect, Dispatch } from 'react-redux'

import { openModal } from '../../common/actions/layout'
import { addBookmark, deleteBookmark } from '../../common/actions/user/bookmark'
import { createFavoriteCollection } from '../../common/actions/user/collection'
import { itemDecorator, ItemDecoratorFunction } from '../../common/utils/item'
import { IRootState } from '../../common/reducers'

import {
  getUserCartItems,
  getUserCollections,
  getUserFavoriteCollectionID
} from '../../common/selectors/user'
import { ICommonLocation } from '../../common/utils/location/types'

interface IOwnProps {
  render: (itemDecorator: ItemDecoratorFunction) => React.ReactElement | null
  listName?: string
}

interface IStateProps {
  currentSite: Site
  collections: any
  cartItems: any
  favoriteCollectionID: any
  token: string
  location: ICommonLocation
}

interface IDispatchProps {
  deleteBookmark: (
    collectionID: any,
    itemID: any,
    id: any,
    isFavouriteCollection: any
  ) => any
  addBookmark: (
    collectionId: any,
    itemId: any,
    isFavouriteCollection: any
  ) => any
  openModal: (data: any) => any
  createFavoriteCollection: () => any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const {
    common: { currentSite },
    user: { token },
    router: { location }
  } = state

  return {
    currentSite,
    collections: getUserCollections(state),
    cartItems: getUserCartItems(state),
    favoriteCollectionID: getUserFavoriteCollectionID(state),
    token,
    location
  }
}

const mapDispatchToProps = (dispatch: Dispatch<IRootState>): IDispatchProps => {
  return {
    deleteBookmark: (collectionID, itemID, id, isFavouriteCollection) =>
      dispatch(deleteBookmark(
        collectionID,
        itemID,
        id,
        isFavouriteCollection
      ) as any),
    addBookmark: (collectionId, itemId, isFavouriteCollection) =>
      dispatch(addBookmark(collectionId, itemId, isFavouriteCollection) as any),
    openModal: data => dispatch(openModal(data)),
    createFavoriteCollection: () => dispatch(createFavoriteCollection())
  }
}

export type Props = IOwnProps & IDispatchProps & IStateProps

const WithItemDecoratorComponent = ({
  currentSite,
  openModal,
  token,
  favoriteCollectionID,
  collections,
  deleteBookmark,
  addBookmark,
  createFavoriteCollection,
  location,
  listName,
  render
}: Props) => {
  const itemDecoratorFunction = itemDecorator(
    currentSite,
    openModal,
    !token,
    favoriteCollectionID,
    collections,
    deleteBookmark,
    addBookmark,
    createFavoriteCollection,
    location,
    listName
  )

  return render(itemDecoratorFunction)
}

const WithItemDecorator = connect<
  IStateProps,
  IDispatchProps,
  IOwnProps,
  IRootState
>(
  mapStateToProps,
  mapDispatchToProps
)(WithItemDecoratorComponent)

export default WithItemDecorator
